/**
 * Created by wangjianwen on 2017/10/16.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import Lockr from 'lockr'
import {WhiteList,LocalStorageWay} from './config'
import {subscribePlugin} from './subscribePlugin'
import common from './common'
import examInfo from './examInfo';
import examRegInfo from './examRegInfo';

Vue.use(Vuex);

const plugin = subscribePlugin()
let store = new Vuex.Store({
    modules: {
        common,
        examInfo,
        examRegInfo
    },
    plugins: [plugin]
});

for (let m in store.state) {
    for (let key in store.state[m]) {
        let data;
        if (WhiteList.indexOf(key) != -1) {
            continue;
        }
        else if (LocalStorageWay.indexOf(key) != -1) {
            data = Lockr.get(key)
        }
        else {
            try {
                data = JSON.parse(window.sessionStorage.getItem(key)).data;
            } catch (e) {
            }
        }
        if (data) {
            store.state[m][key] = data
        }
    }
}
export default store